import { useState } from 'react';
import { ConcertBulkUpload } from './ConcertBulkUpload';
import { CdBulkUpload } from './CdBulkUpload';
import { OralHistoryBulkUpload } from './OralHistoryBulkUpload';
import { BioBulkUpload } from './BioBulkUpload';
import './BulkUpload.css';

const BULK_TYPES = [
  {
    id: 'concert',
    label: 'Concerts',
    description: 'People, songs, and concert events (existing MCG Jazz template).',
  },
  {
    id: 'cd',
    label: 'CDs / Albums',
    description: 'Album metadata, tracks, production credits, liner notes.',
  },
  {
    id: 'oral_history',
    label: 'Oral histories',
    description: 'Interview transcripts in Otter, concert Q&A, or documentary formats.',
  },
  {
    id: 'bios',
    label: 'Artist bios',
    description: 'One multi-entry .docx of artist biographies (Pittsburgh Jazz Legends format).',
  },
];

/**
 * Bulk Upload shell — picks the data type, then dispatches to the
 * type-specific uploader. Each child owns its own file input, parser,
 * preview, and submit. The outer `onSubmit` prop receives a tagged payload
 * `{ type, data }` so AdminPortal can route to the right backend endpoint.
 */
export function BulkUpload({ onSubmit }) {
  const [bulkType, setBulkType] = useState('concert');
  const active = BULK_TYPES.find((t) => t.id === bulkType);

  return (
    <section className="BulkUpload">
      <div className="AdminPortal-ingestionTypes" role="tablist" aria-label="Bulk upload type">
        {BULK_TYPES.map((t) => (
          <button
            key={t.id}
            type="button"
            role="tab"
            aria-selected={bulkType === t.id}
            className={`AdminPortal-ingestionType ${bulkType === t.id ? 'AdminPortal-ingestionType--active' : ''}`}
            onClick={() => setBulkType(t.id)}
          >
            {t.label}
          </button>
        ))}
      </div>

      <p className="BulkUpload-typeDescription">{active.description}</p>

      {bulkType === 'concert' && <ConcertBulkUpload onSubmit={onSubmit} />}
      {bulkType === 'cd' && <CdBulkUpload onSubmit={onSubmit} />}
      {bulkType === 'oral_history' && <OralHistoryBulkUpload onSubmit={onSubmit} />}
      {bulkType === 'bios' && <BioBulkUpload onSubmit={onSubmit} />}
    </section>
  );
}
